import React from 'react';
export function ProductPack() {
  return <section className="py-16 px-4 bg-gradient-to-b from-[#FEF3E2] to-[#FFF8F0] overflow-hidden" data-id="element-130">
      <div className="max-w-6xl mx-auto text-center" data-id="element-131">
        <h2 className="text-3xl md:text-5xl font-extrabold mb-4" data-id="element-132">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D4850A] to-[#B8720A]" data-id="element-133">
            TODO ESTO ES TUYO HOY
          </span>
        </h2>
        <p className="text-xl text-[#9B8578] mb-12" data-id="element-134">
          El pack completo para convertirte en experto en budines
        </p>

        <div className="relative w-full max-w-4xl mx-auto h-[400px] md:h-[600px] cursor-pointer group" onClick={() => document.getElementById('compra')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-135">
          {/* Background glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-[#D4850A]/10 rounded-full blur-[100px] pointer-events-none" data-id="element-136"></div>

          {/* Main Book */}
          <img src="https://cdn.magicpatterns.com/uploads/njMAY3XguUNyW1FQwxsdek/0_cover_1.png" alt="Libro Principal" className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1/2 md:w-[40%] z-30 drop-shadow-2xl transform transition-transform duration-500 group-hover:scale-105" data-id="element-137" />

          {/* Bonus 1 - Back Left */}
          <img src="https://cdn.magicpatterns.com/uploads/fWrSuNCw9LpS5kCptS5t7g/bono_1.png" alt="Bono 1" className="absolute top-[40%] left-[15%] md:left-[20%] -translate-y-1/2 w-[35%] md:w-[25%] z-20 drop-shadow-xl -rotate-12 transform transition-transform duration-500 group-hover:-translate-x-4 group-hover:-rotate-6" data-id="element-138" />

          {/* Bonus 2 - Back Right */}
          <img src="https://cdn.magicpatterns.com/uploads/fNMRDkw1z7jg2D6B7MAj2p/bono_2.png" alt="Bono 2" className="absolute top-[40%] right-[15%] md:right-[20%] -translate-y-1/2 w-[35%] md:w-[25%] z-20 drop-shadow-xl rotate-12 transform transition-transform duration-500 group-hover:translate-x-4 group-hover:rotate-6" data-id="element-139" />

          {/* Bonus 3 - Front Left */}
          <img src="https://cdn.magicpatterns.com/uploads/6J65ZVSEbjBSnvsYzg3hwK/bono_3.png" alt="Bono 3" className="absolute bottom-[10%] left-[5%] md:left-[10%] w-[40%] md:w-[30%] z-40 drop-shadow-2xl -rotate-6 transform transition-transform duration-500 group-hover:-translate-x-6 group-hover:-rotate-3" data-id="element-140" />

          {/* Bonus 4 - Front Right */}
          <img src="https://cdn.magicpatterns.com/uploads/9n84b1w2G9XGH8gVrcXbGY/bono_4.png" alt="Bono 4" className="absolute bottom-[10%] right-[5%] md:right-[10%] w-[40%] md:w-[30%] z-40 drop-shadow-2xl rotate-6 transform transition-transform duration-500 group-hover:translate-x-6 group-hover:rotate-3" data-id="element-141" />
        </div>

        <p className="text-2xl text-[#6B5344] mt-8 font-medium" data-id="element-142">
          El valor total de todo este contenido supera fácilmente los{' '}
          <span className="line-through text-red-500" data-id="element-143">$39.990 ARS.</span>
        </p>
      </div>
    </section>;
}